import { render, staticRenderFns } from "./AppBottomNav.vue?vue&type=template&id=5f86905a&scoped=true"
import script from "./AppBottomNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBottomNav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppBottomNav.vue?vue&type=style&index=0&id=5f86905a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86905a",
  null
  
)

export default component.exports